import React from 'react';
import styles from './Stepper.css';
import TEXTS from '@/constants/texts';

const Stepper: React.FunctionComponent = () => (
	<div className={styles.stepper}>
		<div>
			<p className={styles.mainTitle}>{TEXTS.stepsTitle}</p>
		</div>

		<div className={styles.stepsBlock}>
			<div className={styles.line} />

			<div className={styles.steps}>
				{TEXTS.steps.map((step, index) => (
					<div className={styles.step} key={index}>
						<div className={styles.stepCircle} />
						<p className={styles.stepText}>{step}</p>
					</div>
				))}
			</div>
		</div>

		<a href="mailto:json-ld@corp.mail.ru" className={styles.link}>
			<div className={styles.button}>
				<p className={styles.buttonText}>Связаться с нами</p>
			</div>
		</a>
	</div>
);

export default Stepper;
